import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Helmet } from "react-helmet";
import { Heading } from "@chakra-ui/react";
import PageHeading from "@inspire/ui/chakra/layout/PageHeading";
import Panel from "@inspire/ui/general/Panel";
import PageSpinner from "@inspire/ui/chakra/layout/PageSpinner";
import ConditionalWrapper from "@inspire/ui/general/ConditionalWrapper";
var Page = function(param) {
    var isLoading = param.isLoading, withPanel = param.withPanel, panelProps = param.panelProps, title = param.title, subtitle = param.subtitle, children = param.children, heading = param.heading, headingProps = param.headingProps, headingIsTitle = param.headingIsTitle, breadcrumb = param.breadcrumb, meta = param.meta;
    if (isLoading) return /*#__PURE__*/ _jsx(PageSpinner, {});
    return /*#__PURE__*/ _jsx(ConditionalWrapper, {
        condition: withPanel,
        thenWrapper: function(panelChildren) {
            return /*#__PURE__*/ _jsx(Panel, _object_spread_props(_object_spread({
                compactOnMobile: true
            }, panelProps), {
                children: panelChildren
            }));
        },
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Helmet, {
                    children: [
                        /*#__PURE__*/ _jsx("title", {
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            property: "og:title",
                            content: title
                        }),
                        /*#__PURE__*/ _jsx("meta", {
                            property: "twitter:title",
                            content: title
                        }),
                        meta
                    ]
                }),
                breadcrumb,
                (headingIsTitle && title || heading) && /*#__PURE__*/ _jsxs(PageHeading, _object_spread_props(_object_spread({}, headingProps), {
                    children: [
                        headingIsTitle ? title : heading,
                        subtitle && /*#__PURE__*/ _jsx(Heading, {
                            as: "h6",
                            size: "xs",
                            children: subtitle
                        })
                    ]
                })),
                children
            ]
        })
    });
};
export default Page;
